import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Plus, SearchIcon } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import Swal from "sweetalert2";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import CargoColumn from "Common/Components/CargoColumn/CargoColumn";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import { useDispatch } from "react-redux";
import {
  addCommitmentReducer,
  deleteCommitmentReducer,
  SMSCommitmentFarmerReducer,
} from "slices/Commitment/reducer";

interface FormField {
  name: string;
  label: string;
  type: string;
  placeholder: string;
  colSpan: any;
}
const Cargo = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [productListYearCropValue, setproductListYearCropValue] = useState<any>(
    localStorage.getItem("crop_year_id")
  );
  const [IsEdit, setIsEdit] = useState<any>();
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const [Datevalues, setDatevaluesValues] = useState<DateObject | null>(
    new DateObject({ calendar: persian }).setLocale(persian_fa)
  );
  // دریافت ورودی  از کاربر
  const formFields: FormField[] = [
    {
      name: "",
      label: "شماره بارنامه:",
      type: "text",
      placeholder: "شماره بارنامه",
      colSpan: 6,
    },
    {
      name: "",
      label: "شماره همراه:",
      type: "text",
      placeholder: "شماره همراه",
      colSpan: 6,
    },
    {
      name: "",
      label: "وزن بار:",
      type: "text",
      placeholder: "وزن بار",
      colSpan: 6,
    },
    {
      name: "",
      label: "درصد افت:",
      type: "text",
      placeholder: "درصد افت",
      colSpan: 6,
    },
    {
      name: "",
      label: "کمک کرایه",
      type: "text",
      placeholder: "کمک کرایه:",
      colSpan: 6,
    },
    {
      name: "",
      label: "نام راننده:",
      type: "text",
      placeholder: "نام راننده",
      colSpan: 6,
    },
    {
      name: "",
      label: "عیار:",
      type: "text",
      placeholder: "عیار",
      colSpan: 6,
    },
    {
      name: "",
      label: "وزن خاک :",
      type: "text",
      placeholder: "وزن خاک ",
      colSpan: 6,
    },
  ];
  const [dataListfactory, setdataListfactory] = useState<any>([]);
  const [dataListFactoryID, setdataListFactoryID] = useState<any>();
  const [searchFarmerSelect, setSearchFarmerSelect] = useState<any>();
  const dispatch = useDispatch<any>();
  const handlerUpdate = (ele: any) => {
    setIsEdit(true);
    setShow(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const CropYearID = localStorage.getItem("crop_year_id");
        let url =
          "https://api.havirkesht.ir/factory/?sort_by=updated_at&sort_order=desc&crop_year_id=${CropYearID}";
        if (searchFarmerSelect && searchFarmerSelect.trim() != "") {
          url += `&search=${encodeURIComponent(searchFarmerSelect.trim())}`;
        }

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListfactory(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, [searchFarmerSelect]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize);
    setCurrentPage(newPage);

    fetchData(newPage, newSize);
  };
  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue]);

  // Get Data
  const fetchData = async (page: any, size: any) => {
    try {
      const cropYear_ID = localStorage.getItem("crop_year_id");
      let url = `https://api.havirkesht.ir/commitment/?sort_by=updated_at&sort_order=desc&crop_year_id=${cropYear_ID}&size=${size}&page=${page}`;
      if (searchValue && searchValue.trim() !== "") {
        url += `&search=${encodeURIComponent(searchValue.trim())}`;
      }

      const res: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });

      const items = res?.data?.items || [];
      setData(items);
      setalldata(res?.data?.total);
      setTotalPages(res?.data?.pages);
      setload(items.length < 1);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      setErrorMessage(
        error.response
          ? "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
          : "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
      );
      setload(true);
    }
  };
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      dispatch(deleteCommitmentReducer(eventData)).then((result: any) => {
        if (result?.payload.dataID) {
          Swal.fire({
            title: "حذف بار",
            text: "اطلاعات با موفقیت حذف شد",
            icon: "success",
          });
          setreload(!reload);
        } else {
          Swal.fire({
            title: "حذف بار",
            text: "مشکل در حذف دیتا",
            icon: "error",
          });
        }
      });
      setDeleteModal(false);
      setEventData(null);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      withdrawal_amount: "",
      amount_of_land: "",
      commitment_number: "",
    },
    validationSchema: Yup.object({
      withdrawal_amount: Yup.number().required(
        "لطفاً میزان برداشت را وارد کنید"
      ),
      amount_of_land: Yup.number().required("این فیلد الزامی  است"),
      commitment_number: Yup.number().required(" لطفا شماره بار را وارد کنید "),
    }),
    onSubmit: async (values) => {
      try {
        if (!dataListFactoryID) {
          setShow(true);
          return toast.error("لطفا تمامی مقادر را وارد کنید");
        }
        const newData = {
          ...values,
          date_set: Datevalues ? Datevalues.format("YYYY/MM/DD") : null,
        };
        dispatch(addCommitmentReducer(newData))
          .then((result: any) => {
            if (result.payload?.id) {
              const farmerID = Number(result.payload?.id);
              dispatch(SMSCommitmentFarmerReducer(farmerID));
              Swal.fire({
                title: "ثبت بار",
                text: "اطلاعات با موفقیت ثبت شد",
                icon: "success",
              });
              validation.resetForm();
              setreload(!reload);
            } else {
              Swal.fire({
                title: "ثبت بار",
                text: "ثبت اطلاعات با خطا مواجه شد",
                icon: "error",
              });
            }
          })
          .catch((err: any) => {
            Swal.fire({
              title: "ثبت بار",
              text: "ثبت اطلاعات با خطا مواجه شد",
              icon: "error",
            });
          });
      } catch (error: any) {
        Swal.fire({
          title: "ثبت بار",
          text: "ثبت اطلاعات با خطا مواجه شد",
          icon: "error",
        });
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = CargoColumn({ onClickDelete, handlerUpdate });
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت بار کشاورزان" title=" هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />

      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body ">
          <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:items-center sm:justify-between">
            {/* بخش عنوان و جستجو */}
            <div className="flex  flex-col w-full gap-3 sm:flex-row sm:items-center sm:grow">
              <h6 className="text-15 grow whitespace-nowrap">
                مجموع بارها (
                <b className="total-Employs mb-5">{alldata?.toString()}</b>)
                <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                  <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                  <div className="relative w-full sm:w-64">
                    <input
                      type="text"
                      className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                      placeholder="جستجو..."
                      value={searchValue}
                      onChange={(e) => setsearchValue(e.target.value)}
                    />
                    <span className="absolute inset-y-0 left-2 flex items-center text-gray-400">
                      <SearchIcon />
                    </span>
                  </div>
                </label>
              </h6>
              <div className="flex items-center  gap-3">
                <div className="w-full  sm:w-auto">
                  <TableDropDownSmall onSelect={handleSelect} />
                </div>
              </div>

              {/* بخش دکمه‌ها */}

              <div className="shrink-0">
                <Link
                  to="#!"
                  onClick={toggle}
                  type="button"
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
                >
                  <span className="align-middle rtl">ثبت بار چغندر</span>{" "}
                  <Plus className="inline-block size-4 rtl" />
                </Link>
              </div>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customnumberfortable={11}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
          {/* صفحه‌بندی */}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[50rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">
            {IsEdit ? "به روز رسانی اطلاعات" : "افزودن بار چغندر"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4"></div>
                <div className="grid grid-cols-12 gap-4">
                  {formFields.map((field: FormField, index: number) => (
                    <div
                      key={index}
                      className={`col-span-12 flex gap-4 items-center lg:col-span-${
                        field.colSpan || 6
                      } text-gray-800`}
                    >
                      <label className="inline-block whitespace-nowrap dark:text-white mr-1 mb-2 text-base font-medium">
                        {field.label}
                      </label>
                      <input
                        type={field.type}
                        className="form-input w-full placeholder-gray-400 placeholder:text-[12px]"
                        placeholder={field.placeholder}
                        name={field.name}
                        autoComplete="off"
                        onChange={validation.handleChange}
                        value={
                          validation.values[
                            field.name as keyof typeof validation.values
                          ]
                        }
                      />

                      {/* نمایش خطا زیر هر فیلد */}
                      {validation.touched[
                        field.name as keyof typeof validation.touched
                      ] &&
                        typeof validation.errors[
                          field.name as keyof typeof validation.errors
                        ] === "string" && (
                          <p className="text-red-400 text-sm mt-1">
                            {String(
                              validation.errors[
                                field.name as keyof typeof validation.errors
                              ]
                            )}
                          </p>
                        )}
                    </div>
                  ))}
                  {/* فیلد تاریخ برداشت */}
                  <div className="col-span-12 flex gap-4 items-center lg:col-span-6 text-gray-800">
                    <label className="inline-block whitespace-nowrap dark:text-white mr-1 mb-2 text-base font-medium">
                      تاریخ برداشت:
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      value={Datevalues}
                      onChange={setDatevaluesValues}
                      format="YYYY/MM/DD"
                      calendarPosition="bottom-right"
                      containerClassName="w-full"
                      inputClass="form-input w-full p-2 border border-gray-200 rounded bg-white text-gray-900 dark:text-white dark:bg-[#132337]"
                    />
                  </div>

                  {/* فیلد انتخاب کارخانه */}
                  <div className="col-span-12 flex gap-4 items-center lg:col-span-6 text-gray-800">
                    <label className="inline-block whitespace-nowrap dark:text-white mr-1 mb-2 text-base font-medium">
                      کارخانه:
                    </label>
                    <div className="w-full">
                      <Select
                        options={dataListfactory.map((item: any) => ({
                          value: item.id,
                          label: item.factory_name,
                        }))}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        onChange={(selected: any) =>
                          setdataListFactoryID(selected.value)
                        }
                        onInputChange={(inputValue) =>
                          setSearchFarmerSelect(inputValue)
                        }
                        menuPortalTarget={document.body}
                        placeholder="جستوجو..."
                        noOptionsMessage={() => "داده‌ای دریافت نشد"}
                        loadingMessage={() => "در حال بارگذاری..."}
                        className="w-full my-react-select-container dark:text-white"
                        classNamePrefix="my-react-select"
                        maxMenuHeight={300}
                        isSearchable
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            {!!IsEdit ? "بروز رسانی " : " ثبت اطلاعات"}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Cargo;
